module.exports = __webpack_public_path__ + "img/fob_symbol_blue.49b580c3.svg";